export const enumBreakpoint = {
    PC : 992,
    MOBILE:0
}